export const DOCUMENTS_GROUPAMA = {
  CONDITIONS_GENERALES_URL:
    "https://www.snapiculture.com/wp-content/uploads/2025/10/conditions-generales-assurances-apicoles-SNA-2026.pdf",
  FRANCHISES_GARANTIES_URL: "https://www.snapiculture.com/wp-content/uploads/2025/10/franchises-sna-2026.pdf",
};
